// extracted by mini-css-extract-plugin
module.exports = {"italic":"RichMark_italic__TbBd4","underline":"RichMark_underline__ffYCJ","code":"RichMark_code__IIB3K","bold":"RichMark_bold__f4_K2"};